import { render, staticRenderFns } from "./keshijieshao.vue?vue&type=template&id=a47f7b0c&scoped=true&"
import script from "./keshijieshao.vue?vue&type=script&lang=js&"
export * from "./keshijieshao.vue?vue&type=script&lang=js&"
import style0 from "./keshijieshao.vue?vue&type=style&index=0&id=a47f7b0c&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47f7b0c",
  null
  
)

export default component.exports